import { ChemistryQuiz } from '@efdigital/ll-xceed-v2/components/coaching/coachee/chemistry-quiz.gts';
import type { CoachingCoacheeCohortCoachesModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/coaches';
import {
  PAGE_WRAPPER,
  PAGE_WRAPPER_CHROME,
} from '@efdigital/ll-xceed-v2/utils/layout';
import { LinkTo } from '@ember/routing';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';

interface CoachingCoacheeCohortCoachesSignature {
  Args: {
    model: CoachingCoacheeCohortCoachesModel;
    controller: unknown;
  };
}

function showQuizInput(model: CoachingCoacheeCohortCoachesModel): boolean {
  return !!(model.chemistryQuiz?.quiz && model.chemistryQuiz?.answer?.draft);
}

export default class CoachingCoacheeCohortCoaches extends Component<CoachingCoacheeCohortCoachesSignature> {
  @service declare router: RouterService;

  ariaCurrent = (routeName: string): 'page' | undefined =>
    this.router.currentRouteName === routeName ? 'page' : undefined;

  <template>
    {{#if (showQuizInput @model)}}
      <div class={{PAGE_WRAPPER}}>
        {{#if @model.chemistryQuiz}}
          <ChemistryQuiz
            @quiz={{@model.chemistryQuiz.quiz}}
            @answer={{@model.chemistryQuiz.answer}}
            @initialMode="input"
          />
        {{/if}}
      </div>
    {{else}}
      <div class={{PAGE_WRAPPER_CHROME}}>
        <nav aria-label="Coach views">
          <ul
            class="nav nav-pills nav-fill coaching-dashboard-coach-tabs ll-bg-raised rounded-4 rounded-sm-pill p-1 shadow-sm w-100 flex-column flex-sm-row mb-4"
          >
            <li class="nav-item">
              <LinkTo
                @route="coaching.coachee.cohort.coaches.index"
                class="nav-link rounded-pill px-2 px-lg-4 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1 gap-md-2 w-100"
                aria-current={{this.ariaCurrent
                  "coaching.coachee.cohort.coaches.index"
                }}
              >
                <span class="d-sm-none">Pool</span>
                <span class="d-none d-sm-inline">Coaching Pool</span>
              </LinkTo>
            </li>
            <li class="nav-item">
              <LinkTo
                @route="coaching.coachee.cohort.coaches.shortlist"
                class="nav-link rounded-pill px-2 px-lg-4 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1 gap-md-2 w-100"
                aria-current={{this.ariaCurrent
                  "coaching.coachee.cohort.coaches.shortlist"
                }}
              >
                <span class="d-sm-none">Shortlist</span>
                <span class="d-none d-sm-inline">Your Shortlist</span>
                <span
                  class="border px-2 px-md-3 rounded-pill"
                  aria-label="{{@model.planner.chemistryAndChosenPartnerships.length}}
                coaches"
                >{{@model.planner.chemistryAndChosenPartnerships.length}}</span>
              </LinkTo>
            </li>
            <li class="nav-item">
              <LinkTo
                @route="coaching.coachee.cohort.coaches.chosen"
                class="nav-link rounded-pill px-2 px-lg-4 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1 gap-md-2 w-100"
                aria-current={{this.ariaCurrent
                  "coaching.coachee.cohort.coaches.chosen"
                }}
              >
                Your Coach
                <span
                  class="border px-2 px-md-3 rounded-pill"
                  aria-label="{{@model.planner.chosenPartnerships.length}} coaches"
                >{{@model.planner.chosenPartnerships.length}}</span>
              </LinkTo>
            </li>
          </ul>
        </nav>
      </div>

      {{outlet}}
    {{/if}}
  </template>
}
